export enum TemporaryAccessState {
    ExtendSuccess = "ExtendSuccess",
    ExtendPending = "ExtendPending",
    ExtendFailed = "ExtendFailed",
    RevokeFailed = "RevokeError",
    RevokePending = "RevokePending",
    GrantFailed = "GrantFailed",
    GrantPending = "GrantPending",
    OK = "OK"
}
